import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Product from "../pages/product/page";
import Contact from "../pages/contact/page";
import News from "../pages/news/page";
import AdminLogin from "../pages/admin/login/page";
import AdminCatalog from "../pages/admin/products/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/index",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/product",
    element: <Product />,
  },
  {
    path: "/product/:catId/:subId",
    element: <Product />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <Navigate to="/admin/products" replace />,
  },
  {
    path: "/admin/products",
    element: <AdminCatalog />,
  },
  {
    path: "/admin/brands",
    element: <Navigate to="/admin/products" replace />,
  },
  {
    path: "/admin/news",
    element: <Navigate to="/admin/products" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
